import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withStyles} from 'material-ui/styles';
import styles from './style/styles';
import {setUserTab} from '../layout/actions';
import UsersTabs from '../users/UsersTabs';
import {fetchedUsers} from './actions';
import UsersGrid from './UsersGrid';
import Roles from '../roles/index';
import {Heading} from '../../components/heading/heading';
import UsersFilters from './UsersFilters';
import {
    setGridFilter,
    unsetGridFilter,
} from '../grid/actions';
import ScrollToTop from '../../components/scroll-top/ScrollToTop';

class UsersSettings extends Component {

    componentWillMount() {
        this.props.fetchedUsers();
    }

    onFiltersApply() {
        this._child.reload();
    }

    setFilter(filter, value) {
        if (filter && value === '') {
            this.props.unsetGridFilter(filter, value, this.props.gridId)
        } 

        this.props.setGridFilter(filter, value, this.props.gridId)
    }

    resetGridFilters(filters) {
        filters.map(filter =>
            this.props.unsetGridFilter(filter.id, filter.value, this.props.gridId)
        )
    }

    render() {
        return (
            <div>
                <UsersTabs
                    activeTab={this.props.activeUsersTab}
                    classes={this.props.classes}
                    onChange={(event, value) => {
                        this.props.setUserTab(value);
                    }}
                />
                <Heading
                    title={this.props.activeUsersTab === 0 ? 'Users List' : 'Users Roles'}
                />
                {this.props.activeUsersTab === 0 && [
                    <UsersFilters
                        key={0}
                        classes={this.props.classes}
                        filters={this.props.usersFilters}
                        onFiltersApply={this.onFiltersApply.bind(this)}
                        setFilter={this.setFilter.bind(this)}
                        resetFilters={this.resetGridFilters.bind(this)}
                    />,
                    <UsersGrid
                        key={1}
                        users={this.props.gridUsers}
                        ref={(child) => {this._child = child}}
                        gridId={this.props.gridId}
                        onFetchedItems={(data, totalPages) => {
                            this.props.fetchedUsers(data, totalPages);
                        }}
                    />,
                    <ScrollToTop key={2} />
                ]}

                {this.props.activeUsersTab === 1 && <Roles />}

            </div>
        )
    }
}

const mapStateToProps = state => ({
    activeUsersTab: state.layout.activeUsersTab,
    gridUsers: state.users.allUsers,
    usersFilters: state.grid.usersGrid.filtered,
});

const ConnectedUsersSettings = connect(mapStateToProps, {
    setUserTab,
    fetchedUsers,
    setGridFilter,
    unsetGridFilter,
})(withStyles(styles)(UsersSettings));

ConnectedUsersSettings.defaultProps = {gridId: 'usersGrid'};

export default ConnectedUsersSettings;


// WEBPACK FOOTER //
// ./src/containers/users/index.js